import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FileInterface } from '@app/interfaces/file.interface';
import { environment } from '@env/environment';
import { UsersService } from '@app/services/users.service';
import { firstValueFrom, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FileHelper {
    private readonly httpClient = inject(HttpClient);
    private readonly usersService = inject(UsersService);

    fileUploaded: Subject<void> = new Subject();

    public async downloadFile(file: FileInterface) {
        const blob = await this.getFileBlob(file.path);

        const url = window.URL.createObjectURL(blob);

        const a: any = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = file.name;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    public async getFileBlob(fileId: string): Promise<Blob> {
        const headers = new HttpHeaders({
            Authorization: this.usersService.accessToken,
        });

        const downloadedFile: any = await firstValueFrom(
            this.httpClient.get(environment.url.backendApi + '/files/' + fileId, { headers })
        );

        let byteString;
        if (downloadedFile.uri.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(downloadedFile.uri.split(',')[1]);
        } else {
            byteString = unescape(downloadedFile.uri.split(',')[1]);
        }
        // separate out the mime component
        const mimeString = downloadedFile.uri.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }
}
